import React from 'react';
import './MoreTrigger.less';
import {Trigger} from 'new-components/elements/trigger/Trigger';
import AboutIcon from 'new-images/about.svg';

export const MoreTrigger = ({onClick}) => {
	return (
		<Trigger onClick={onClick}>
			<span className="more-trigger" dangerouslySetInnerHTML={{__html: AboutIcon}}></span>
		</Trigger>
	);
};
